import {useEffect, useState } from "react";
import * as XLSX from "xlsx";

import API from "../../services/api";
import "./AdminUsersPage.css";
import "../../styles/Navbar.css";



function AdminUsersPage() {

  const [users, setUsers] = useState([]);

    const [showVipOnly, setShowVipOnly] = useState(false);

  const [search, setSearch] = useState("");

 const loadUsers = async () => {

const res =
  await API.get(
    "/users/admin/users"
  );

setUsers(
  res.data.users || []
);

};

  useEffect(() => {

    loadUsers();

  }, []);



  const updateUser =
    async (user) => {

    await API.put(
  `/users/admin/users/${user._id}`,
  {
    role: user.role,
    isVip: user.isVip,
    vipUntil: user.vipUntil,
    isBanned: user.isBanned
  }
);

      alert("Modifié");

    };

  const deleteUser =
    async (id) => {

      if (

        !window.confirm(
          "Supprimer ?"
        )

      ) return;

      await API.delete(

        `/users/admin/users/${id}`

      );

      loadUsers();

    };

const filteredUsers =
(Array.isArray(users)
 ? users
 : []
).filter(user => {

  const emailMatch =
    user.email
      ?.toLowerCase()
      .includes(
        search.toLowerCase()
      );

  const vipMatch =
    !showVipOnly ||
    user.isVip;

  return (
    emailMatch &&
    vipMatch
  );

});

const totalUsers =
users.length;

const vipUsers =
users.filter(
  u => u.isVip
).length;

const admins =
users.filter(
  u => u.role === "admin"
).length;

const today =
new Date();

const todayUsers =
users.filter(user => {

  const created =
    new Date(
      user.createdAt
    );

  return (

    created
      .toDateString()

    ===

    today
      .toDateString()

  );

}).length;


  const vipCount =
    users.filter(
      user => user.isVip
    ).length;

    const exportExcel =
() => {

  const worksheet =

    XLSX.utils
    .json_to_sheet(users);

  const workbook =

    XLSX.utils
    .book_new();

  XLSX.utils.book_append_sheet(

    workbook,

    worksheet,

    "Utilisateurs"

  );

  XLSX.writeFile(

    workbook,

    "users.xlsx"

  );

};

    

  return (

    <div className="admin-users">

      <h1>

        Gestion Utilisateurs

      </h1>

      <div>

        Utilisateurs :
        {users.length}

        {" | "}

        VIP :
        {vipCount}

      </div>

      <label>

<input

  type="checkbox"

  checked={showVipOnly}

  onChange={() =>
    setShowVipOnly(
      !showVipOnly
    )
  }

/>


VIP uniquement

</label>




      <input

        type="text"

        placeholder="Recherche email"

        value={search}

        onChange={(e) =>
          setSearch(
            e.target.value
          )
        }

      />

<div className="stats-cards">

  <div>
    👥 {totalUsers}
  </div>

  <div>
    💎 {vipUsers}
  </div>

  <div>
    🛡️ {admins}
  </div>

  <div>

📅 {todayUsers}

</div>

<button
  onClick={exportExcel}
>

📥 Export Excel

</button>

</div>

      <table>

        <thead>

          <tr>

            <th>Nom</th>

            <th>Email</th>

            <th>Rôle</th>

            <th>VIP</th>

            <th>Fin VIP</th>

            <th>Banni</th>

            <th>Actions</th>

          </tr>

        </thead>

        <tbody>

          {filteredUsers.map(
            user => (

            <tr
              key={user._id}
            >

              <td>
                {user.name}
              </td>

              <td>
                {user.email}
              </td>

              <td>

                <select

                  value={user.role}

                  onChange={(e)=>{

                    user.role =
                      e.target.value;

                    setUsers(
                      [...users]
                    );

                  }}

                >

                  <option value="user">

                    User

                  </option>

                  <option value="admin">

                    Admin

                  </option>

                </select>

              </td>

              <td>

                <input

                  type="checkbox"

                  checked={
                    user.isVip
                  }

                  onChange={(e)=>{

                    user.isVip =
                      e.target.checked;

                    setUsers(
                      [...users]
                    );

                  }}

                />

              </td>

              <td>

                <input

                  type="date"

                  value={
                    user.vipUntil

                    ?

                    new Date(
                      user.vipUntil
                    )

                    .toISOString()

                    .split("T")[0]

                    : ""

                  }

                  onChange={(e)=>{

                    user.vipUntil =
                      e.target.value;

                    setUsers(
                      [...users]
                    );

                  }}

                />

              </td>

              <td>

  <input

    type="checkbox"

    checked={
      user.isBanned || false
    }

    onChange={(e) => {

      user.isBanned =
        e.target.checked;

      setUsers(
        [...users]
      );

    }}

  />

</td>


              <td>

                <button

                  onClick={()=>

                    updateUser(
                      user
                    )

                  }

                >

                  💾

                </button>

                <button

                  onClick={()=>

                    deleteUser(
                      user._id
                    )

                  }

                >

                  🗑️

                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>

  );

}

export default AdminUsersPage;